var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"extras"},[_c('ul',_vm._l((_vm.data),function(ref){
var extra = ref.extra;
var label = ref.label;
var value = ref.value;
return _c('li',{key:extra,class:{ select: _vm.isSelected(extra) },on:{"click":function($event){$event.preventDefault();return _vm.select(extra)}}},[_c('div',[_c('b',[_vm._v(_vm._s(label)+":")])]),_c('div',[_c('span',[_vm._v(_vm._s(value)+" €")]),_c('div',{staticClass:"radio"})])])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }